// extracted by mini-css-extract-plugin
module.exports = {"animation":"styles_animation__NOFNr","lds-dual-ring":"styles_lds-dual-ring__EjeSX"};